import { render } from "./resolution-input.vue?vue&type=template&id=ed98fdec"
import script from "./resolution-input.vue?vue&type=script&lang=js"
export * from "./resolution-input.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__